import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-chevron-left-large.tsx
/**
* icon.24.chevron.left.large
*
* Keywords: arrow, back, navigation, previous, return, westward, directional, pointer
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTMuODU0IDcuNjQ2YS41LjUgMCAwIDEgMCAuNzA4TDEwLjIwNyAxMmwzLjY0NyAzLjY0NmEuNS41IDAgMCAxLS43MDguNzA4bC00LTRhLjUuNSAwIDAgMSAwLS43MDhsNC00YS41LjUgMCAwIDEgLjcwOCAwIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-711
*/
const Icon24ChevronLeftLarge = memo(function Icon24ChevronLeftLarge(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M13.854 7.646a.5.5 0 0 1 0 .708L10.207 12l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M13.854 7.146a.5.5 0 0 1 0 .708L10.207 11.5l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24ChevronLeftLarge };

//# sourceMappingURL=icon-24-chevron-left-large.js.map